<!-- 類似券面複数利用制限のダイアログ -->
<template>
  <ItemDialog ref="DialogInvalidFrameInInterval" image-type="alert">
    <template #content-area>
      <p>
        連続してチケットをご利用いただく場合は、３時間の時間の経過が必要です。<br />
        次に使える時刻をチケット画面でご確認ください。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="戻る"
        action-type="btn-primary"
        @clicked="closeDialog"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogInvalidFrameInInterval",
  setup() {
    const DialogInvalidFrameInInterval = ref(null);

    const openDialog = () => {
      DialogInvalidFrameInInterval.value.open();
    };

    const closeDialog = () => {
      DialogInvalidFrameInInterval.value.close();
    };

    return {
      DialogInvalidFrameInInterval,
      openDialog,
      closeDialog,
    };
  },
};
</script>
